<template>
  <section class="all-cases-view" id="uaqcPrintPreviewResults">
    <div class="container-default">
      <div class="primary-content-view-new" v-loading="loading">
        <div
          class="listings listings__table listings__all-cases"
          id="all-cases-listings"
        >
          <h2 class="qc_header">Urinalysis QC Results</h2>
          <el-table :data="urinalysisResults" class="print-table">
            <el-table-column
              prop="accession_id"
              label="ACCESSION ID"
              width="120px"
            >
              <template #default="scope">
                <span class="accesion">{{ scope.row.accession_id }}</span>
              </template>
            </el-table-column>
            <el-table-column label="DATE" min-width="65px">
              <template #default="scope">
                {{ formatDate(scope.row.time) }}
              </template>
            </el-table-column>
            <el-table-column label="LEUKOCYTES(Leu/μL)" min-width="100px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "LEUKOCYTES") }}
              </template>
            </el-table-column>
            <el-table-column label="GLUCOSE" min-width="50px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "GLUCOSE") }}
              </template>
            </el-table-column>
            <el-table-column label="pH" min-width="40px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "pH") }}
              </template>
            </el-table-column>
            <el-table-column label="NITRITE(mg/dL)" min-width="80px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "NITRITE") }}
              </template>
            </el-table-column>
            <el-table-column label="PROTEIN(g/L)" min-width="80px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "PROTEIN") }}
              </template>
            </el-table-column>
            <el-table-column label="SPECIFIC GRAVITY" min-width="90px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "SPECIFIC GRAVITY") }}
              </template>
            </el-table-column>
            <el-table-column
              label="KETONE (ACETOACETIC ACID)"
              min-width="140px"
            >
              <template #default="scope">
                {{
                  getResultValue(scope.row.results, "KETONE (ACETOACETIC ACID)")
                }}
              </template>
            </el-table-column>
            <el-table-column label="BILIRUBIN(μmol/L)" min-width="100px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "BILIRUBIN") }}
              </template>
            </el-table-column>
            <el-table-column label="UROBILINOGEN(μmol/L)" min-width="120px">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "UROBILINOGEN") }}
              </template>
            </el-table-column>
            <el-table-column label="BLOOD(Ery/μ)">
              <template #default="scope">
                {{ getResultValue(scope.row.results, "BLOOD") }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "UrinalysisPrint",
  data() {
    return {
      urinalysisResults: [],
      loading: false,
    };
  },
  computed: {
    ...mapGetters("qcCharts", ["getUrinalysisQcResults"]),
  },
  methods: {
    formatDate(dateString) {
      const date = new Date(dateString);
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      const year = date.getFullYear();
      return `${month}-${day}-${year}`;
    },
    getResultValue(results, testName) {
      const result = results.find((result) => result.test === testName);
      return result ? result.value : "-";
    },
    async fetchUaQcResults() {
      try {
        this.loading = true;
        let params = {};
        if (this.$route.query.from_date && this.$route.query.to_date) {
          params.from_date = this.$route.query.from_date;
          params.to_date = this.$route.query.to_date;
        }
        await this.$store.dispatch("qcCharts/fetchUrinalysisQcResults", params);
        if (this.getUrinalysisQcResults && this.getUrinalysisQcResults.length) {
          this.urinalysisResults = [...this.getUrinalysisQcResults];
        } else {
          this.urinalysisResults = [];
        }
        this.loading = false;
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
  },
  mounted() {
    // const results = this.$route.query.results;
    // this.urinalysisResults = results ? JSON.parse(results) : [];
    this.fetchUaQcResults();
    setTimeout(() => {
      window.print();
    }, 5000); // Delay for 1 second
  },
};
</script>

<style lang="scss" scoped>
.all-cases-view {
  .tabel-card {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    .heading-block {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 1rem;
      .heading {
        color: #273480;
        font-weight: 600;
      }
    }
  }
}
.qc_header {
  color: #1b2459;
  font-weight: 600;
  font-size: 16px;
  text-align: center;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0;
}
.no_data {
  text-align: center;
  padding-top: 3rem;
  color: #eb5757;
}
</style>

<style lang="scss">
#uaqcPrintPreviewResults {
  .listings__table .el-table table thead tr th .cell {
    text-transform: none !important;
  }
  .el-table {
    background: transparent !important;
    table-layout: fixed;
    width: 100% !important;
    overflow: initial;
    position: relative;

    table {
      border-spacing: 0;

      thead {
        height: 35px;

        tr {
          border: 1px solid #e0e0e0;

          th {
            .cell {
              font-size: 11.5px;
            }
            &:first-child {
              border-radius: 0;
            }

            &:last-child {
              border-radius: 0;
              border-right: 3px solid #e0e0e0 !important;
            }

            &.el-table__cell {
              padding: 0;
              border: 1px solid #e0e0e0;
            }
          }
        }
      }

      tbody {
        tr {
          border: 1px solid #e0e0e0;

          td {
            &:first-child {
              border-radius: 0;
            }

            &:last-child {
              border-radius: 0;
              border-right: 3px solid #e0e0e0 !important;
            }

            &.el-table__cell {
              padding: 0;
              border: 1px solid #e0e0e0;
            }
          }
        }
      }
    }
  }
}

/* @media print {
  @page {
    size: landscape; 
  }

  .el-button {
    display: none;
  }

  .primary-content-view-new {
    page-break-before: auto;
    page-break-after: auto;
    page-break-inside: avoid;
    width: 100%;
    overflow: visible !important;
  }

  .el-table {
    width: 100% !important;
    position: relative;
  }

  .el-table__header-wrapper,
  .el-table__body-wrapper,
  .el-table__footer-wrapper {
    overflow: visible !important; /* Prevent clipping 
    // overflow: initial !important;
  }
} 
  */
</style>
